import { AtlasV2KeyMetricsPageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasV2KeyMetricsPageLayout';
import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';

export default function getAtlasV2KeyMetricsPageLayout() {
  return {
    CustomPageContainer: GenericPageContainer,
    enableComparison: false,
    widgets: [
      {
        name: 'keyMetricsPageLayout',
        CustomComponent: AtlasV2KeyMetricsPageLayout,
        view: {}
      }
    ],
    containerStyle: {},
    dataConfig: {}
  };
}
